(() => {
  if (customElements.get('malzauber-offers')) return;
  class MalzauberOffers extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.dialog = this.querySelector('dialog');
      if (!this.dialog || typeof this.dialog.showModal !== 'function') return;
      this.listeners = new AbortController();
      this.storageKey = 'malzauber-newcustomer-v1';
      this.serverVisible = this.dataset.offerVisible === 'true';
      const options = { signal: this.listeners.signal };
      // Footer and floating button both open this single form.
      document.addEventListener('click', (event) => {
        const button = event.target instanceof Element ? event.target.closest('[data-mzo-open]') : null;
        if (!button || button.disabled) return;
        event.preventDefault();
        this.returnFocus = button;
        if (button.hasAttribute('data-mzo-newsletter')) {
          const newsletter = this.querySelector('[data-mzo-newsletter-details]');
          if (newsletter) newsletter.open = true;
        }
        this.openOffer();
      }, options);
      this.querySelector('[data-mzo-close]')?.addEventListener('click', () => this.dialog.close(), options);
      this.dialog.addEventListener('close', () => {
        // During a CAPTCHA handoff the dialog is reopened in the same task.
        if (this.dialog.open) return;
        this.stopWatchingCaptcha();
        this.captchaPaused = false;
        this.dialog.inert = false;
        this.dialog.classList.remove('mzo-dialog--captcha');
        this.refreshButtons();
        const originalVisible = this.returnFocus?.isConnected && this.returnFocus.getClientRects().length > 0;
        const target = originalVisible ? this.returnFocus : this.querySelector('.mzo-band [data-mzo-open]');
        target?.focus({ preventScroll: true });
      }, options);
      this.dialog.addEventListener('click', (event) => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
      }, options);
      this.querySelector('form')?.addEventListener('submit', () => this.setFlag('submitted', true), options);
      window.addEventListener('pagehide', () => {
        this.stopWatchingCaptcha();
        if (this.dialog.open) this.dialog.close();
      }, options);
      window.addEventListener('pageshow', () => this.onPageShown(), options);
      document.addEventListener('shopify:section:load', () => this.refreshButtons(), options);
      this.onPageShown();
    }
    disconnectedCallback() {
      this.listeners?.abort();
      this.stopWatchingCaptcha();
      this.ready = false;
    }
    getFlag(name) {
      try { return sessionStorage.getItem(`${this.storageKey}:${name}`) === '1'; }
      catch { return false; }
    }
    setFlag(name, value) {
      try {
        if (value) sessionStorage.setItem(`${this.storageKey}:${name}`, '1');
        else sessionStorage.removeItem(`${this.storageKey}:${name}`);
      } catch { /* Signup still works when browser storage is unavailable. */ }
    }
    onPageShown() {
      const result = this.querySelector('[data-mzo-result]');
      if (result && (this.getFlag('submitted') || location.hash === '#MalzauberNewsletter')) {
        this.setFlag('submitted', false);
        if (result.dataset.mzoResult === 'success') this.setFlag('subscribed', true);
        const newsletter = this.querySelector('[data-mzo-newsletter-details]');
        if (newsletter) newsletter.open = true;
        this.openOffer(true);
      }
      this.refreshButtons();
    }
    refreshButtons() {
      const visible = this.serverVisible;
      document.querySelectorAll('[data-mzo-open]').forEach((button) => {
        button.hidden = !visible || (button.hasAttribute('data-mzo-teaser') && this.dialog.open);
      });
    }
    openOffer(result = false) {
      if (this.dialog.open || (!result && !this.serverVisible)) return;
      if (!result && document.querySelector('dialog[open]')) return;
      this.dialog.showModal();
      this.refreshButtons();
      const focusTarget = result ? this.querySelector('[data-mzo-result]') : this.querySelector('[data-mzo-close]');
      focusTarget?.focus({ preventScroll: true });
      this.watchCaptcha();
    }
    watchCaptcha() {
      this.stopWatchingCaptcha();
      const schedule = () => {
        if (!this.dialog.open || this.captchaFrame) return;
        this.captchaFrame = requestAnimationFrame(() => {
          this.captchaFrame = 0;
          this.syncCaptchaLayer();
        });
      };
      this.captchaObserver = new MutationObserver(schedule);
      this.captchaObserver.observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['style', 'class', 'hidden', 'aria-hidden', 'src'] });
      this.captchaPoll = window.setInterval(schedule, 200);
      schedule();
    }
    stopWatchingCaptcha() {
      this.captchaObserver?.disconnect();
      window.clearInterval(this.captchaPoll);
      this.captchaPoll = 0;
      if (this.captchaFrame) cancelAnimationFrame(this.captchaFrame);
      this.captchaFrame = 0;
    }
    visibleCaptchaChallenge() {
      return [...document.querySelectorAll('iframe[src*="hcaptcha.com/"][src*="frame=challenge"]')].find((frame) => {
        const rect = frame.getBoundingClientRect();
        if (rect.width <= 0 || rect.height <= 0 || !frame.getClientRects().length) return false;
        for (let element = frame; element instanceof HTMLElement; element = element.parentElement) {
          const style = getComputedStyle(element);
          if (style.display === 'none' || style.visibility === 'hidden' || style.visibility === 'collapse' || Number(style.opacity) === 0) return false;
        }
        return true;
      });
    }
    syncCaptchaLayer() {
      if (!this.dialog.open) return;
      const challenge = this.visibleCaptchaChallenge();
      if (challenge && !this.captchaPaused) {
        this.captchaPaused = true;
        this.dialog.classList.add('mzo-dialog--captcha');
        this.dialog.close();
        this.dialog.inert = true;
        this.dialog.show();
        challenge.focus({ preventScroll: true });
      } else if (!challenge && this.captchaPaused) {
        this.captchaPaused = false;
        this.dialog.classList.remove('mzo-dialog--captcha');
        this.dialog.close();
        this.dialog.inert = false;
        this.dialog.showModal();
        this.querySelector('[data-mzo-close]')?.focus({ preventScroll: true });
      }
    }
  }
  customElements.define('malzauber-offers', MalzauberOffers);
})();
